<template>
  <div class="">
    <img src="@/assets/flag_italy.svg" alt="" class="flag" v-if="item == 'italy'">
    <img src="@/assets/flag_un.svg" alt="" class="flag" v-if="item == 'everywhere'">
    <img src="@/assets/flag_australia.svg" alt="" class="flag" v-if="item == 'australia'">
    <img src="@/assets/flag_france.png" alt="" class="flag" v-if="item == 'france'">
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "InputFlag",
  props: {
    label: String,
    title: String,
    tag: String,
    color: String,
    value: String,
    prefix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      item: this.value,
    };
  },
  watch: {
    item: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.item = val;
    },
  },
};
</script>

<style lang="scss">
 .flag {
    width: 80px;
    height: auto;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
    border: 2px solid white;
  }
</style>
